module.exports = __webpack_public_path__ + "img/name_z.ddf02521.png";